import React, { Component } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { Spin } from 'antd';

import header from 'modules/AllBillers/assets/header.png';
import DANA_ICON_URL from 'modules/AllBillers/assets/dana_icon.svg';
import { LockIcon } from 'modules/AllBillers/components/Icons';

import * as FormComponent from 'modules/AllBillers/components/FormBuilder';
import RepeatOrder from '../../../components/FormBuilder/components/RepeatOrder/RepeatOrder.component';

import '../FormDetail.style.less';
export default class FormDetailH5 extends Component {
  _renderSelectedBiller = () => {
    const { billerTitle } = this.props;
    return (
      <div className="selected-biller">
        <div className="biller-name">{billerTitle || '[BILLER TITLE]'}</div>
        <div className="biller">
          <div className="biller-info">
            <div className="biller-icon">
              <img src={DANA_ICON_URL} alt="icon-dana" />
            </div>
            <div className="biller-name-text">Provider</div>
          </div>
          <div className="biller-btn">Change</div>
        </div>
      </div>
    );
  };

  _renderPlaceholder = locked => (
    <div className="content">
      <div
        className={`placeholder-component ${locked ? 'locked' : ''}`}
        key="placeholder_1"
      />
      <div
        className={`placeholder-component ${locked ? 'locked' : ''}`}
        key="placeholder_2"
      />
      {!this.props.isPayment && (
        <>
          <div className="placeholder-component" key="placeholder_3" />
          <div className="placeholder-component" key="placeholder_4" />
        </>
      )}
    </div>
  );

  _renderDynamicPreview = lang => {
    const isUseBothHeader = this.props.sectionHeader === 'both';
    const reduceContentHeight = isUseBothHeader ? 499 : 384;
    const defaultContentHeight = isUseBothHeader ? 201 : 316;

    const activeComponents = get(this.props, 'activeComponents', []);

    return (
      <div
        className="content"
        style={{
          minHeight:
            this.props.dimension.height > 700
              ? this.props.dimension.height - reduceContentHeight
              : defaultContentHeight,
        }}
      >
        {activeComponents.map(field => {
          const generalObj = { ...get(field, `config.${lang}.general`) };

          Object.keys(
            FormComponent[field.component].builderConfig.general,
          ).forEach(key => {
            generalObj[key] = generalObj[key] || ' ';
          });
          const otherProps = {
            helper: get(field, `config.${lang}.helper`, null),
            limit: { min: 6, max: 18 },
            ...generalObj,
          };

          return (
            <Field
              key={field.name}
              name={field.name}
              withSeparator={activeComponents.length > 1}
              component={FormComponent[field.component]}
              {...otherProps}
              intl={this.props.intl}
            />
          );
        })}
      </div>
    );
  };

  _renderBannerSection = () => {
    const {
      sectionHeader,
      intl: { formatMessage },
      intl,
      lang,
    } = this.props;

    const RO = (
      <RepeatOrder
        orders={[
          {
            icon: DANA_ICON_URL,
            id: 'dana1',
            name: 'dana',
            account: '123412341234',
            amount: 150000,
          },
          {
            icon: DANA_ICON_URL,
            id: 'dana2',
            name: 'dana',
            account: '123412341234',
            amount: 150000,
          },
          {
            icon: DANA_ICON_URL,
            id: 'dana3',
            name: 'dana',
            account: '123412341234',
            amount: 150000,
          },
        ]}
        intl={intl}
        onSelect={() => {}}
        title={
          lang === 'en'
            ? formatMessage({ id: 'comp.repeatOrder' })
            : 'Pembelian Terakhir'
        }
      />
    );

    if (sectionHeader === 'none') return null;
    if (sectionHeader === 'repeat') return RO;
    if (sectionHeader === 'banner') return <div id="banner" />;
    return (
      <>
        <div id="banner" />
        {RO}
      </>
    );
  };

  render() {
    const {
      title,
      btnText,
      dimension,
      lang,
      isPayment,
      enablePayment,
    } = this.props;

    const locked = isPayment && !enablePayment;
    const backgroundColor = locked ? '#7d7d7d' : '#108ee9';

    return (
      <div className="h5-preview-device">
        <span className="form-section">
          {isPayment ? 'B. Payment Input Page' : 'A. Form Page'}
        </span>

        <div
          className="h5-wrapper"
          style={{ width: dimension.width, minHeight: dimension.height }}
        >
          <div>
            <img
              src={header}
              className="statusbar"
              alt="statusbar"
              style={{
                filter: locked ? 'grayscale(100%)' : '',
              }}
            />
            <div
              className="title-bar"
              style={{
                width: dimension.width - 70,
                margin: dimension.width < 350 ? '23px 35px' : '33px 35px',
                backgroundColor,
              }}
            >
              {title}
            </div>
            <Spin spinning={this.props.loading}>
              {!isPayment && this._renderBannerSection()}
              {!isPayment && this._renderSelectedBiller()}
              {isPayment && (
                <div className="payment-banner" style={{ backgroundColor }}>
                  <img src={DANA_ICON_URL} alt="icon-dana" />

                  <div className="content-banner">
                    <span className="cust-number">Customer Number</span>
                    <span>[Biller Name] - [Provider Name]</span>
                  </div>
                </div>
              )}

              {get(this.props, 'activeComponents', []).length && !locked
                ? this._renderDynamicPreview(lang)
                : this._renderPlaceholder(locked)}
            </Spin>
          </div>

          <div className="footer">{btnText.toUpperCase()}</div>

          {locked && (
            <div
              className="h5-lock"
              style={{ width: dimension.width, minHeight: dimension.height }}
            >
              <div
                className="lock-content"
                style={{
                  width: dimension.width,
                  minHeight: dimension.height / 3,
                }}
              >
                <LockIcon size={60} />
                <div>
                  Only available if supported channel is
                  <br /> set to “Direct Bill Payment (Genesis)
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

FormDetailH5.propTypes = {
  dimension: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  billerTitle: PropTypes.string,
  title: PropTypes.string,
  activeComponents: PropTypes.array,
  loading: PropTypes.bool,
  btnText: PropTypes.string,
  lang: PropTypes.string,
  intl: PropTypes.object,
  sectionHeader: PropTypes.string,
  isPayment: PropTypes.bool,
  enablePayment: PropTypes.bool,
};
